module.exports = __webpack_public_path__ + "img/Withdrawal_Crypto_auto.fc3dad74.png";